"use strict";
//
// Copyright © 2024 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMarkup = getMarkup;
exports.jsonToPmNode = jsonToPmNode;
exports.pmNodeToJSON = pmNodeToJSON;
exports.jsonToText = jsonToText;
exports.htmlToMarkup = htmlToMarkup;
exports.htmlToJSON = htmlToJSON;
exports.jsonToHTML = jsonToHTML;
const core_1 = require("@tiptap/core");
const html_1 = require("@tiptap/html");
const model_1 = require("@tiptap/pm/model");
const text_core_1 = require("@hcengineering/text-core");
const extensions_1 = require("../extensions");
/** @public */
const defaultSchema = (0, core_1.getSchema)(extensions_1.defaultExtensions);
/** @public */
function getMarkup(editor) {
    return (0, text_core_1.jsonToMarkup)(editor?.getJSON());
}
// Markup
/** @public */
function jsonToPmNode(json, schema, extensions) {
    schema ??= extensions == null ? defaultSchema : (0, core_1.getSchema)(extensions ?? extensions_1.defaultExtensions);
    return model_1.Node.fromJSON(schema, json);
}
/** @public */
function pmNodeToJSON(node) {
    return node.toJSON();
}
/** @public */
function jsonToText(node, schema, extensions) {
    const pmNode = jsonToPmNode(node, schema, extensions);
    return pmNode.textBetween(0, pmNode.content.size, '\n', '');
}
// export function markupToText (markup: Markup, schema?: Schema, extensions?: Extensions): string {
//   const pmNode = markupToPmNode(markup, schema, extensions)
//   return pmNode.textBetween(0, pmNode.content.size, '\n', '')
// }
// HTML
/** @public */
function htmlToMarkup(html, extensions) {
    const json = htmlToJSON(html, extensions);
    return (0, text_core_1.jsonToMarkup)(json);
}
// /** @public */
// export function markupToHTML (markup: Markup, extensions?: Extensions): string {
//   const json = markupToJSON(markup)
//   return jsonToHTML(json, extensions)
// }
/** @public */
function htmlToJSON(html, extensions) {
    extensions = extensions ?? extensions_1.defaultExtensions;
    return (0, html_1.generateJSON)(html, extensions, { preserveWhitespace: 'full' });
}
/** @public */
function jsonToHTML(json, extensions) {
    extensions = extensions ?? extensions_1.defaultExtensions;
    return (0, html_1.generateHTML)(json, extensions);
}
//# sourceMappingURL=utils.js.map